import { routes as escalationList } from './escalationdashboard'

export default [...escalationList];


// WEBPACK FOOTER //
// ./ClientApp/globalapp/routes.js